import React, { useReducer, useEffect, useRef } from 'react';
import { wrapPercents } from '../../../internal-components/conditional-logic/wrapPercents';
import log from '../../../utils/log';
import FieldsConditionsQueryBuilderView from '../view/FieldsConditionsQueryBuilderView';

const ConditionReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'update': {
      const { deleteKeys = [], ...updatePayload } = payload;
      const newState = { ...state, ...updatePayload };

      // Remove keys listed in deleteKeys
      deleteKeys.forEach(key => {
        delete newState[key];
      });

      return newState;
    }

    default:
      return state;
  }
};

// const initialReducerState = {
//   op: '',
//   value: ''
// };

const FieldsConditionsQueryBuilderEngine = ({
  conditions,
  compareType,
  update = () => log('Field conditions updated!')
}) => {
  const [data, dispatch] = useReducer(ConditionReducer, conditions);

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    update(data);
  }, [data]);

  const updateDateRule = obj => {
    dispatch({
      type: 'update',
      payload: obj
    });
  };

  const viewProps = {
    compareType,
    op: data.op,
    value: data.value,
    updateOp: nOp => dispatch({ type: 'update', payload: { op: nOp } }),
    updateVal: nVal =>
      dispatch({
        type: 'update',
        payload: {
          value:
            (data.op === 'ILIKE' || data.op === 'NOT ILIKE') && nVal
              ? wrapPercents(nVal)
              : nVal
        }
      }),
    updateDateRule,
    intervalUnit: compareType === 'date' ? data.intervalUnit : undefined,
    intervalCount: compareType === 'date' ? data.intervalCount : undefined
  };
  return <FieldsConditionsQueryBuilderView {...viewProps} />;
};

export default FieldsConditionsQueryBuilderEngine;
